/* Craftmark nameplate bulk list
 * Customers download a spreadsheet template for this nameplate page, fill one row per nameplate,
 * upload it (.xlsx / .xls / .csv), review and fix each row (with a to-scale preview), then add
 * every row to the cart as its own line item with the same properties + design picture the
 * single-nameplate builder saves. Uses window.NPBulk from assets/nameplate-builder.js.
 */
(function () {
  'use strict';
  function boot() {
    var A = window.NPBulk;
    if (!A || document.getElementById('npb')) return;
    var T = A.type, ON = A.optionNames, OV = A.optionValues;
    var hasMat = ON.indexOf('Material') >= 0, colorOpt = ON.indexOf('Color') >= 0, colorList = colorOpt ? OV[ON.indexOf('Color')] : (A.colorProps || []);
    var hasColor = colorList.length > 0, hasFill = T === 'brass_ss';
    var MAXL = 8, MAXROWS = 250;
    var MOUNT_KEYS = ['sides', 'corners', 'top', 'topcorners', 'adhesive'];

    /* ---------- helpers ---------- */
    function h(tag, attrs, kids) {
      var e = document.createElement(tag);
      if (attrs) Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (k === 'class') e.className = v; else if (k === 'html') e.innerHTML = v; else if (k === 'text') e.textContent = v;
        else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), v);
        else if (v !== false && v != null) e.setAttribute(k, v === true ? '' : v);
      });
      (kids || []).forEach(function (k) { if (k != null) e.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); });
      return e;
    }
    function norm(x) { return String(x == null ? '' : x).toLowerCase().replace(/[“”″"]/g, '"').replace(/[™®]/g, '').replace(/\s+/g, ' ').trim(); }
    function letters(x) { return norm(x).replace(/[^a-z]/g, ''); }
    function money(n) { return '$' + n.toFixed(2); }
    function pretty(v) { return String(v).replace(/[“”]/g, '"'); }

    // "3/4", ".75", "2-1/2", "2 1/2", '2"'  ->  number
    function num(t) {
      t = String(t).replace(/["“”″]|in(ch(es)?)?\b/gi, '').trim();
      var m = /^(\d+)[\s-]+(\d+)\/(\d+)$/.exec(t); if (m) return +m[1] + m[2] / m[3];
      m = /^(\d+)\/(\d+)$/.exec(t); if (m) return m[1] / m[2];
      m = /^\d*\.?\d+$/.exec(t); if (m) return parseFloat(t);
      return NaN;
    }
    function dimsOf(t) {
      var parts = String(t).replace(/[×]/g, 'x').split(/\s*(?:x|by|\*)\s*/i);
      if (parts.length !== 2) return null;
      var a = num(parts[0]), b = num(parts[1]);
      return isNaN(a) || isNaN(b) ? null : [Math.min(a, b), Math.max(a, b)];
    }

    /* ---------- value matching ---------- */
    var sizeVals = OV[ON.indexOf('Size')] || [];
    function matchSize(raw) {
      var d = dimsOf(raw); if (!d) return null;
      for (var i = 0; i < sizeVals.length; i++) { var p = A.parseSize(sizeVals[i]), a = Math.min(p.h, p.w), b = Math.max(p.h, p.w); if (Math.abs(a - d[0]) < 0.02 && Math.abs(b - d[1]) < 0.02) return sizeVals[i]; }
      return null;
    }
    function matchMaterial(raw) {
      var vals = OV[ON.indexOf('Material')] || [], n = norm(raw); if (!n) return null;
      for (var i = 0; i < vals.length; i++) if (norm(vals[i]) === n) return vals[i];
      if (T === 'brass_ss') {
        if (/brass/.test(n)) return vals.filter(function (v) { return /brass/i.test(v); })[0] || null;
        if (/stain|^ss$|304|steel/.test(n)) return vals.filter(function (v) { return /stain/i.test(v); })[0] || null;
        return null;
      }
      var eighth = /1\/8|\.125|eighth/.test(n), sixteenth = /1\/16|\.0625|sixteenth/.test(n);
      if (eighth || sixteenth) return vals.filter(function (v) { return eighth ? /1\/8/.test(v) : /1\/16/.test(v); })[0] || null;
      return null;
    }
    function matchColor(raw) {
      var n = letters(raw); if (!n) return null;
      for (var i = 0; i < colorList.length; i++) if (letters(colorList[i]) === n) return colorList[i];
      n = n.replace(/letters?|with|on|background/g, '');
      for (i = 0; i < colorList.length; i++) if (letters(colorList[i]) === n) return colorList[i];
      var hits = colorList.filter(function (c) { return letters(c).indexOf(n) === 0; });
      return hits.length ? hits[0] : null;
    }
    function matchMount(raw) {
      var n = norm(raw); if (!n) return null;
      if (/adhes|peel|stick|tape|no hole|none/.test(n)) return 'adhesive';
      if (/top/.test(n) && /corner|2|two/.test(n)) return 'topcorners';
      if (/top/.test(n)) return 'top';
      if (/corner|four|\b4\b/.test(n)) return 'corners';
      if (/side|end|hole|\b2\b|two|center/.test(n)) return 'sides';
      return null;
    }
    function matchHeights(raw) {
      var n = norm(raw);
      if (!n || /auto|fit|any|largest/.test(n)) return { list: [] };
      var bits = n.split(/\s*[,;|]\s*/).filter(Boolean), out = [];
      for (var i = 0; i < bits.length; i++) {
        var v = num(bits[i]), hit = null;
        A.sizes.forEach(function (s) { if (Math.abs(s.v - v) < 0.01) hit = s.v; });
        if (hit == null) return { list: [], bad: raw };
        out.push(hit);
      }
      return { list: out };
    }

    /* ---------- rows ---------- */
    var rows = [], seq = 0;
    function defaults() {
      var r = { id: ++seq, qty: 1, opts: {}, color: hasColor ? colorList[0] : null, fill: 'Black filled', mount: 'sides', orient: 'H', align: 'center', heights: [], lines: [''], issues: {} };
      ON.forEach(function (n, i) { r.opts[n] = A.current[n] != null ? A.current[n] : OV[i][0]; });
      if (colorOpt) r.color = r.opts.Color;
      return r;
    }
    function apiRow(r) {
      var o = {}; Object.keys(r.opts).forEach(function (k) { o[k] = r.opts[k]; });
      if (colorOpt) o.Color = r.color;
      var ls = r.lines.filter(function (t) { return String(t).trim() !== ''; });
      return { opts: o, color: colorOpt ? null : r.color, fill: r.fill, mount: r.mount, orient: r.orient, align: r.align,
        mode: r.heights.length ? 'line' : 'fit',
        lines: ls.map(function (t, i) { return { t: t, s: r.heights.length ? (r.heights[i] || r.heights[r.heights.length - 1]) : 0.5 }; }) };
    }
    function check(r) {
      var res = A.evaluate(apiRow(r)), errs = [];
      Object.keys(r.issues).forEach(function (k) { if (r.issues[k]) errs.push(r.issues[k]); });
      if (!(r.qty >= 1)) errs.push('Enter a quantity of 1 or more.');
      res.errors.forEach(function (e) { if (errs.indexOf(e) < 0) errs.push(e); });
      res.errors = errs; res.ok = !errs.length;
      return res;
    }
    function tierPrice(v, q) {
      var base = v.price / 100, tiers = String(v.ppq || '').split(',').map(function (x) { var p = x.split('='); return { q: parseInt(p[0], 10), p: parseFloat(p[1]) }; }).filter(function (t) { return !isNaN(t.q) && !isNaN(t.p); });
      var p = base; tiers.forEach(function (t) { if (q >= t.q) p = t.p; });
      return p;
    }

    /* ---------- spreadsheet columns ---------- */
    function headers() {
      var c = ['Quantity'];
      if (hasMat) c.push('Material');
      c.push('Size');
      if (hasColor) c.push('Color');
      if (hasFill) c.push('Letter Fill');
      c.push('Mounting', 'Orientation', 'Text Align', 'Letter Height');
      for (var i = 1; i <= MAXL; i++) c.push('Line ' + i);
      return c;
    }
    function sizeLabel(v) { var p = A.parseSize(v); return A.fracIn(Math.min(p.h, p.w)).replace(/"/g, '') + ' x ' + A.fracIn(Math.max(p.h, p.w)).replace(/"/g, ''); }
    function exampleRows() {
      var pick = function (want) { return sizeVals.filter(function (v) { var d = dimsOf(v.replace(/[“”]/g, '')); return d && Math.abs(d[0] - want[0]) < 0.02 && Math.abs(d[1] - want[1]) < 0.02; })[0] || sizeVals[Math.min(2, sizeVals.length - 1)]; };
      var ex = [
        { q: 25, size: pick([1, 3]), mount: 'Centered sides', orient: 'Horizontal', align: 'Center', lh: 'Auto', lines: ['AHU-1'] },
        { q: 10, size: pick([2, 4]), mount: 'Four corners', orient: 'Horizontal', align: 'Center', lh: 'Auto', lines: ['BOILER', 'B-1'] },
        { q: 2, size: pick([4, 6]), mount: 'Adhesive back', orient: 'Horizontal', align: 'Center', lh: '1/2, 3/8, 3/8', lines: ['ELECTRICAL', 'ROOM 104', 'AUTHORIZED ONLY'] }
      ];
      if (T === 'brass_ss') ex[2].mount = 'Top corners';
      var mats = OV[ON.indexOf('Material')] || [];
      return ex.map(function (e, i) {
        var row = [e.q];
        if (hasMat) row.push(pretty(mats[i % mats.length] || ''));
        row.push(sizeLabel(e.size));
        if (hasColor) row.push(colorList[i % colorList.length]);
        if (hasFill) row.push(i === 1 ? 'Natural' : 'Black filled');
        row.push(e.mount, e.orient, e.align, e.lh);
        for (var k = 0; k < MAXL; k++) row.push(e.lines[k] || '');
        return row;
      });
    }
    function optionsSheet() {
      var cols = [['Size (height x width, inches)'].concat(sizeVals.map(sizeLabel))];
      if (hasMat) cols.push(['Material'].concat((OV[ON.indexOf('Material')] || []).map(pretty)));
      if (hasColor) cols.push(['Color'].concat(colorList));
      if (hasFill) cols.push(['Letter Fill (brass only)', 'Black filled', 'Natural']);
      cols.push(['Mounting', 'Centered sides', 'Four corners', 'Top center', 'Top corners', 'Adhesive back']);
      cols.push(['Orientation', 'Horizontal', 'Vertical']);
      cols.push(['Text Align', 'Center', 'Left', 'Right']);
      cols.push(['Letter Height', 'Auto (largest that fits)', '2', '1', '3/4', '1/2', '3/8', '1/4', 'One value = every line', 'Or a list per line: 1/2, 3/8']);
      var n = Math.max.apply(null, cols.map(function (c) { return c.length; })), out = [];
      for (var i = 0; i < n; i++) out.push(cols.map(function (c) { return c[i] == null ? '' : c[i]; }));
      out.push([]);
      out.push(['Notes']);
      out.push(['One row per different nameplate. Quantity is how many of that exact nameplate you need.']);
      out.push(['Type each line of text in its own Line column (Line 1 is the top line). Leave unused lines blank.']);
      if (T === 'brass_ss') out.push(['Stainless steel ships with holes (Centered sides, Four corners or Top corners).']);
      out.push(['After uploading you can review a to-scale preview of every row and fix anything before adding to cart.']);
      return out;
    }
    function toCSV(m) { return m.map(function (r) { return r.map(function (c) { c = String(c == null ? '' : c); return /[",\n]/.test(c) ? '"' + c.replace(/"/g, '""') + '"' : c; }).join(','); }).join('\r\n'); }
    function parseCSV(t) {
      var out = [], row = [], cell = '', q = false;
      for (var i = 0; i < t.length; i++) {
        var ch = t[i];
        if (q) { if (ch === '"') { if (t[i + 1] === '"') { cell += '"'; i++; } else q = false; } else cell += ch; }
        else if (ch === '"') q = true;
        else if (ch === ',') { row.push(cell); cell = ''; }
        else if (ch === '\n' || ch === '\r') { if (ch === '\r' && t[i + 1] === '\n') i++; row.push(cell); out.push(row); row = []; cell = ''; }
        else cell += ch;
      }
      if (cell !== '' || row.length) { row.push(cell); out.push(row); }
      return out;
    }
    function loadXLSX() {
      if (window.XLSX) return Promise.resolve(window.XLSX);
      return new Promise(function (ok, bad) {
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
        s.onload = function () { ok(window.XLSX); }; s.onerror = function () { bad(new Error('Could not load the Excel reader')); };
        document.head.appendChild(s);
      });
    }
    function download(name, blob) {
      var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
    }
    var fileBase = { aluminum: 'aluminum', brass_ss: 'brass-stainless', craftflex: 'craftflex', phenolic: 'phenolic' }[T] || 'nameplate';
    function downloadXLSX() {
      setMsg('Preparing your template…');
      loadXLSX().then(function (X) {
        var wb = X.utils.book_new();
        var ws = X.utils.aoa_to_sheet([headers()].concat(exampleRows()));
        ws['!cols'] = headers().map(function (hh) { return { wch: /^Line/.test(hh) ? 22 : Math.max(12, hh.length + 2) }; });
        X.utils.book_append_sheet(wb, ws, 'Nameplates');
        var os = X.utils.aoa_to_sheet(optionsSheet()); os['!cols'] = optionsSheet()[0].map(function () { return { wch: 26 }; });
        X.utils.book_append_sheet(wb, os, 'Options');
        var buf = X.write(wb, { bookType: 'xlsx', type: 'array' });
        download('craftmark-' + fileBase + '-nameplate-list.xlsx', new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        setMsg('');
      }).catch(function () { setMsg('Could not build the Excel file here — use the CSV template instead.', true); });
    }
    function downloadCSV() {
      download('craftmark-' + fileBase + '-nameplate-list.csv', new Blob([toCSV([headers()].concat(exampleRows()))], { type: 'text/csv' }));
    }

    /* ---------- reading an uploaded sheet ---------- */
    function colKey(hh) {
      var n = norm(hh).replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
      var m = /^(?:text )?line (\d+)(?: text)?$|^text (\d+)$/.exec(n);
      if (m) return 'line' + (m[1] || m[2]);
      if (/^(qty|quantity|quan|pcs|pieces|count)/.test(n)) return 'qty';
      if (/letter fill|fill/.test(n)) return 'fill';
      if (/letter (height|size)|text (height|size)|char(acter)? height|letter h/.test(n)) return 'lh';
      if (/orient/.test(n)) return 'orient';
      if (/align|justif/.test(n)) return 'align';
      if (/mount|hole|attach/.test(n)) return 'mount';
      if (/material|metal|thick/.test(n)) return 'mat';
      if (/colou?r|finish/.test(n)) return 'color';
      if (/size|dimension/.test(n)) return 'size';
      if (/^(text|legend|engraving|wording|message)$/.test(n)) return 'text';
      return null;
    }
    function readMatrix(m) {
      m = m.filter(function (r) { return r && r.some(function (c) { return String(c).trim() !== ''; }); });
      var hi = -1, map = null;
      for (var i = 0; i < Math.min(10, m.length); i++) {
        var mm = m[i].map(colKey);
        if (mm.indexOf('size') >= 0 && (mm.indexOf('line1') >= 0 || mm.indexOf('text') >= 0)) { hi = i; map = mm; break; }
      }
      if (hi < 0) return { error: 'We couldn’t find the header row. Please start from our template (it needs at least a Size column and a Line 1 column).' };
      var list = [];
      m.slice(hi + 1).forEach(function (cells) {
        var get = function (k) { var j = map.indexOf(k); return j >= 0 && cells[j] != null ? String(cells[j]).trim() : ''; };
        var lines = [];
        for (var k = 1; k <= 12; k++) { var t = get('line' + k); if (t !== '' || map.indexOf('line' + k) >= 0) lines.push(t); }
        if (!lines.some(Boolean) && get('text')) lines = get('text').split(/\r?\n|\s\|\s|\s\/\s/);
        while (lines.length && !String(lines[lines.length - 1]).trim()) lines.pop();
        if (!lines.length && !get('size')) return;
        list.push(fromCells(get, lines));
      });
      return { rows: list };
    }
    function fromCells(get, lines) {
      var r = defaults(), v;
      var q = parseInt(String(get('qty')).replace(/[^\d]/g, ''), 10); r.qty = q > 0 ? q : 1;
      if (get('size')) { v = matchSize(get('size')); if (v) r.opts.Size = v; else { r.opts.Size = ''; r.issues.size = 'Size “' + get('size') + '” isn’t a size we offer on this page.'; } }
      if (hasMat && get('mat')) { v = matchMaterial(get('mat')); if (v) r.opts.Material = v; else { r.opts.Material = ''; r.issues.mat = 'Material “' + get('mat') + '” isn’t offered on this page.'; } }
      if (hasColor && get('color')) { v = matchColor(get('color')); if (v) r.color = v; else { r.color = ''; r.issues.color = 'Color “' + get('color') + '” isn’t one of our colors for this material.'; } }
      if (hasFill && get('fill')) r.fill = /nat/i.test(get('fill')) ? 'Natural' : 'Black filled';
      if (get('mount')) { v = matchMount(get('mount')); if (v) r.mount = v; else r.issues.mount = 'Mounting “' + get('mount') + '” wasn’t recognized.'; }
      if (/vert/i.test(get('orient'))) r.orient = 'V';
      var al = norm(get('align')); if (/left/.test(al)) r.align = 'left'; else if (/right/.test(al)) r.align = 'right';
      var hs = matchHeights(get('lh')); r.heights = hs.list; if (hs.bad) r.issues.lh = 'Letter height “' + hs.bad + '” — use Auto or 2, 1, 3/4, 1/2, 3/8, 1/4.';
      r.lines = lines.length ? lines.map(function (t) { return String(t); }) : [''];
      return r;
    }
    function handleFile(f) {
      if (!f) return;
      setMsg('Reading ' + f.name + '…');
      var isX = /\.xls[xm]?$/i.test(f.name), rd = new FileReader();
      rd.onload = function () {
        var done = function (m) {
          var res = readMatrix(m);
          if (res.error) { setMsg(res.error, true); return; }
          if (!res.rows.length) { setMsg('No nameplate rows found in ' + f.name + '.', true); return; }
          var room = MAXROWS - rows.length, add = res.rows.slice(0, Math.max(0, room));
          rows = rows.filter(function (r) { return r.lines.some(function (t) { return String(t).trim(); }); }).concat(add);
          draw();
          var bad = add.filter(function (r) { return !check(r).ok; }).length;
          setMsg('Loaded ' + add.length + ' nameplate' + (add.length === 1 ? '' : 's') + ' from ' + f.name + '.' + (bad ? ' ' + (bad === 1 ? '1 needs a quick fix — it’s' : bad + ' need a quick fix — they’re') + ' marked in red below.' : ' Everything checks out.') + (res.rows.length > add.length ? ' (Only the first ' + MAXROWS + ' rows were loaded.)' : ''), !!bad);
        };
        try {
          if (isX) loadXLSX().then(function (X) {
            var wb = X.read(new Uint8Array(rd.result), { type: 'array' });
            var name = wb.SheetNames.filter(function (n) { return /nameplate|sign|list|order/i.test(n); })[0] || wb.SheetNames[0];
            done(X.utils.sheet_to_json(wb.Sheets[name], { header: 1, raw: false, defval: '' }));
          }).catch(function () { setMsg('We couldn’t open that Excel file. Try saving it as CSV and uploading again.', true); });
          else done(parseCSV(String(rd.result).replace(/^\uFEFF/, '')));
        } catch (e) { setMsg('We couldn’t read that file. Please start from our template.', true); }
      };
      if (isX) rd.readAsArrayBuffer(f); else rd.readAsText(f);
    }

    /* ---------- UI ---------- */
    var css = [
      '.npb{--npb-line:#dfe4ec;--npb-mute:#667085;--npb-ink:#1b2130;--npb-navy:#10288a;--npb-soft:#f3f6fb;--npb-bad:#c62828;--npb-ok:#0d7a45;margin:26px 0 8px;border:1px solid var(--npb-line);border-radius:14px;background:#fff;color:var(--npb-ink);font-size:14px}',
      '.npb *{box-sizing:border-box}',
      '.npb .npb-head,.npb .npb-head:hover,.npb .npb-head:focus{display:flex;align-items:center;gap:14px;width:100%;padding:18px 20px;border:0 !important;background:transparent !important;color:var(--npb-ink) !important;text-align:left;cursor:pointer;border-radius:14px;text-transform:none !important;letter-spacing:0 !important;font:inherit;min-height:0;box-shadow:none !important}',
      '.npb-ic{flex:none;width:42px;height:42px;border-radius:12px;background:var(--npb-soft);display:flex;align-items:center;justify-content:center}',
      '.npb-ic svg{width:24px;height:24px;fill:none;stroke:var(--npb-navy);stroke-width:1.8}',
      '.npb-ht{flex:1;min-width:0}.npb-ht b{display:block;font-size:16px;color:var(--npb-ink)}.npb-ht small{display:block;color:var(--npb-mute);font-size:13px;margin-top:2px}',
      '.npb-chev{flex:none;width:12px;height:12px;border-right:2px solid var(--npb-navy);border-bottom:2px solid var(--npb-navy);transform:rotate(45deg);transition:transform .2s;margin-right:6px}',
      '.npb.is-open .npb-chev{transform:rotate(-135deg)}',
      '.npb-body{padding:0 20px 20px;border-top:1px solid var(--npb-line)}',
      '.npb-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin:18px 0 12px;padding:0;list-style:none}',
      '.npb .npb-steps,.npb .npb-steps>li{list-style:none !important;margin-left:0 !important}.npb .npb-steps>li::marker{content:""}',
      '.npb-step{background:var(--npb-soft);border-radius:12px;padding:14px}',
      '.npb-step b{display:block;font-size:14px;margin-bottom:4px}.npb-step p{margin:0 0 10px;color:var(--npb-mute);font-size:13px;line-height:1.45}',
      '.npb .npb-btn,.npb .npb-btn:hover{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:38px;padding:0 14px !important;border-radius:10px;border:1px solid var(--npb-navy) !important;background:#fff !important;color:var(--npb-navy) !important;font-family:inherit;font-weight:600;font-size:13px;line-height:1;cursor:pointer;text-transform:none !important;letter-spacing:0 !important;min-width:0;margin:0 6px 6px 0;box-shadow:none !important}',
      '.npb .npb-btn.is-primary{background:var(--npb-navy) !important;color:#fff !important}',
      '.npb .npb-btn[disabled]{opacity:.45;cursor:not-allowed}',
      '.npb-drop{display:flex;align-items:center;justify-content:center;text-align:center;border:2px dashed #b9c3d6;border-radius:10px;padding:12px;min-height:64px;background:#fff;color:var(--npb-navy);font-weight:600;font-size:13px;cursor:pointer}',
      '.npb-drop.is-over{background:#eaf0ff;border-color:var(--npb-navy)}.npb-drop input{display:none}',
      '.npb-msg{margin:4px 0 10px;padding:10px 12px;border-radius:10px;background:#eef7f1;color:var(--npb-ok);font-size:13px}.npb-msg.is-bad{background:#fdecec;color:var(--npb-bad)}.npb-msg:empty{display:none}',
      '.npb-list{display:flex;flex-direction:column;gap:10px}',
      '.npb-row{display:grid;grid-template-columns:34px 170px 1fr;gap:14px;align-items:start;border:1px solid var(--npb-line);border-radius:12px;padding:12px;background:#fff}',
      '.npb-row.is-bad{border-color:#f0b4b4;background:#fffafa}',
      '.npb-n{font-weight:700;color:var(--npb-mute);text-align:center;padding-top:6px}',
      '.npb-pv{background:#f3f5f9;border-radius:10px;min-height:86px;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:6px}.npb .npb-pv svg{width:auto !important;height:auto !important;max-width:100% !important;display:block}',
      '.npb-f{display:grid;grid-template-columns:repeat(auto-fill,minmax(128px,1fr));gap:8px 10px}',
      '.npb-f label{display:flex;flex-direction:column;gap:3px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.03em;color:var(--npb-mute)}',
      '.npb-f select,.npb-f input,.npb-f textarea{width:100%;height:36px;border:1px solid var(--npb-line) !important;border-radius:8px;padding:0 8px !important;font-family:inherit;font-weight:400;font-size:14px;line-height:1.2;color:var(--npb-ink);background:#fff;text-transform:none;letter-spacing:0;margin:0;min-height:0}',
      '.npb-f textarea{height:auto;min-height:62px;padding:7px 8px !important;resize:vertical;font-weight:600}',
      '.npb-f .npb-txt{grid-column:1/-1}',
      '.npb-f .is-bad select,.npb-f .is-bad input{border-color:var(--npb-bad) !important}',
      '.npb-st{grid-column:1/-1;display:flex;flex-wrap:wrap;align-items:center;gap:6px 14px;font-size:13px}',
      '.npb-st .ok{color:var(--npb-ok);font-weight:600}.npb-st .bad{color:var(--npb-bad)}.npb-st .pr{margin-left:auto;font-weight:700}',
      '.npb .npb-del,.npb .npb-del:hover{border:0 !important;background:transparent !important;color:var(--npb-mute) !important;font-size:12px;text-decoration:underline;cursor:pointer;padding:0 !important;min-width:0;height:auto;text-transform:none !important;letter-spacing:0 !important;box-shadow:none !important}',
      '.npb-foot{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-top:14px;padding-top:14px;border-top:1px solid var(--npb-line)}',
      '.npb-tot{margin-right:auto;font-size:14px}.npb-tot b{font-size:18px}.npb-tot small{display:block;color:var(--npb-mute);font-size:12px}',
      '@media (max-width:767px){.npb-steps{grid-template-columns:1fr}.npb-row{grid-template-columns:1fr;gap:10px}.npb-n{text-align:left;padding:0}.npb-f{grid-template-columns:1fr 1fr}.npb-foot .npb-btn{flex:1}}'
    ].join('\n');
    document.head.appendChild(h('style', { text: css }));

    var wrap = h('section', { class: 'npb', id: 'npb' });
    var head = h('button', { type: 'button', class: 'npb-head', 'aria-expanded': 'false', onclick: function () { toggle(); } }, [
      h('span', { class: 'npb-ic', html: '<svg viewBox="0 0 24 24"><rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/><path d="M3.5 9h17M3.5 14.5h17M9 3.5v17"/></svg>' }),
      h('span', { class: 'npb-ht' }, [h('b', { text: 'Ordering lots of different ' + (window.NP_NOUN || 'nameplate') + 's? Upload your list' }), h('small', { text: 'Fill in our spreadsheet — one row per nameplate — check every one to scale, then add them all to the cart at once.' })]),
      h('span', { class: 'npb-chev' })
    ]);
    var body = h('div', { class: 'npb-body', hidden: true });
    var fileIn = h('input', { type: 'file', accept: '.xlsx,.xls,.csv,text/csv', onchange: function () { handleFile(this.files && this.files[0]); this.value = ''; } });
    var drop = h('label', { class: 'npb-drop' }, [fileIn, h('span', { text: 'Choose your spreadsheet or drop it here (.xlsx or .csv)' })]);
    ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { handleFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    var steps = h('ol', { class: 'npb-steps' }, [
      h('li', { class: 'npb-step' }, [h('b', { text: '1. Download the template' }), h('p', { text: 'It has the right columns for this page, three example rows, and an Options tab listing every size' + (hasColor ? ', color' : '') + ' and mounting choice.' }),
        h('button', { type: 'button', class: 'npb-btn', onclick: downloadXLSX, text: 'Excel (.xlsx)' }), h('button', { type: 'button', class: 'npb-btn', onclick: downloadCSV, text: 'CSV' })]),
      h('li', { class: 'npb-step' }, [h('b', { text: '2. Fill in one row per ' + (window.NP_NOUN || 'nameplate') }), h('p', { text: 'Quantity, size, ' + (hasMat ? 'material, ' : '') + (hasColor ? 'color, ' : '') + 'mounting and your text — one line of text per Line column. Leave Letter Height on Auto and we’ll use the largest standard size that fits.' })]),
      h('li', { class: 'npb-step' }, [h('b', { text: '3. Upload and review' }), h('p', { text: 'Every row gets a to-scale preview. Fix anything marked in red, then add them all to the cart.' }), drop])
    ]);
    var msg = h('div', { class: 'npb-msg', role: 'status' });
    var list = h('div', { class: 'npb-list' });
    var tot = h('div', { class: 'npb-tot' });
    var addBtn = h('button', { type: 'button', class: 'npb-btn is-primary', onclick: addAll, text: 'Add all to cart' });
    var foot = h('div', { class: 'npb-foot' }, [tot,
      h('button', { type: 'button', class: 'npb-btn', onclick: function () { if (rows.length >= MAXROWS) return; rows.push(defaults()); draw(); var tx = list.querySelectorAll('textarea'); if (tx.length) tx[tx.length - 1].focus(); }, text: '+ Add a row' }),
      h('button', { type: 'button', class: 'npb-btn', onclick: function () { if (!rows.length || window.confirm('Clear all ' + rows.length + ' rows?')) { rows = []; draw(); setMsg(''); } }, text: 'Clear list' }),
      addBtn]);
    body.appendChild(steps); body.appendChild(msg); body.appendChild(list); body.appendChild(foot);
    wrap.appendChild(head); wrap.appendChild(body);

    function toggle(open) {
      var o = open == null ? body.hidden : open;
      body.hidden = !o; wrap.classList.toggle('is-open', o); head.setAttribute('aria-expanded', o ? 'true' : 'false');
    }
    function setMsg(t, bad) { msg.textContent = t || ''; msg.classList.toggle('is-bad', !!bad); }

    function sel(label, value, opts, onchange, bad) {
      var s = h('select', { onchange: function () { onchange(this.value); } });
      var known = opts.some(function (o) { return (Array.isArray(o) ? o[0] : o) === value; });
      if (!known) s.appendChild(h('option', { value: '', text: '— choose —', selected: true }));
      opts.forEach(function (o) { var v = Array.isArray(o) ? o[0] : o, l = Array.isArray(o) ? o[1] : o; s.appendChild(h('option', { value: v, text: l, selected: v === value })); });
      return h('label', { class: bad ? 'is-bad' : '' }, [label, s]);
    }
    function heightOpts(r) {
      var o = [['auto', 'Auto (best fit)']].concat(A.sizes.map(function (s) { return [String(s.v), s.l + ' all lines']; }));
      if (r.heights.length > 1) o.push(['keep', 'Per line: ' + r.heights.map(A.labelFor).join(', ')]);
      return o;
    }
    function heightVal(r) { return !r.heights.length ? 'auto' : r.heights.length > 1 ? 'keep' : String(r.heights[0]); }

    function rowEl(r, i) {
      var res = check(r);
      var el = h('div', { class: 'npb-row' + (res.ok ? '' : ' is-bad'), 'data-id': r.id });
      el.appendChild(h('div', { class: 'npb-n', text: String(i + 1) }));
      var pv = h('div', { class: 'npb-pv' });
      try { if (r.opts.Size) pv.appendChild(A.previewSvg(apiRow(r), 158, 92)); } catch (e) {}
      el.appendChild(pv);
      var f = h('div', { class: 'npb-f' });
      var redo = function () { var n = rowEl(r, rows.indexOf(r)); el.replaceWith(n); totals(); };
      var qty = h('input', { type: 'number', min: '1', step: '1', value: r.qty, inputmode: 'numeric', onchange: function () { r.qty = Math.max(1, parseInt(this.value, 10) || 1); redo(); } });
      f.appendChild(h('label', {}, ['Quantity', qty]));
      if (hasMat) f.appendChild(sel('Material', r.opts.Material, (OV[ON.indexOf('Material')] || []).map(function (v) { return [v, pretty(v)]; }), function (v) { r.opts.Material = v; delete r.issues.mat; if (A.allowedMounts(apiRow(r)).indexOf(r.mount) < 0) r.mount = 'sides'; redo(); }, !!r.issues.mat));
      f.appendChild(sel('Size', r.opts.Size, sizeVals.map(function (v) { return [v, sizeLabel(v).replace(/ x /, '" × ') + '"']; }), function (v) { r.opts.Size = v; delete r.issues.size; redo(); }, !!r.issues.size));
      if (hasColor) f.appendChild(sel('Color', r.color, colorList, function (v) { r.color = v; delete r.issues.color; redo(); }, !!r.issues.color));
      if (hasFill && /brass/i.test(r.opts.Material || '')) f.appendChild(sel('Letter fill', r.fill, ['Black filled', 'Natural'], function (v) { r.fill = v; redo(); }));
      var am = A.allowedMounts(apiRow(r));
      f.appendChild(sel('Mounting', r.mount, am.map(function (k) { return [k, A.mounts[k].l]; }), function (v) { r.mount = v; delete r.issues.mount; redo(); }, !!r.issues.mount));
      var p = r.opts.Size ? A.parseSize(r.opts.Size) : null;
      if (p && p.h !== p.w) f.appendChild(sel('Orientation', r.orient, [['H', 'Horizontal'], ['V', 'Vertical']], function (v) { r.orient = v; redo(); }));
      f.appendChild(sel('Align', r.align, [['center', 'Center'], ['left', 'Left'], ['right', 'Right']], function (v) { r.align = v; redo(); }));
      f.appendChild(sel('Letter height', heightVal(r), heightOpts(r), function (v) { if (v === 'auto') r.heights = []; else if (v !== 'keep') r.heights = [parseFloat(v)]; delete r.issues.lh; redo(); }, !!r.issues.lh));
      var ta = h('textarea', { rows: Math.max(2, Math.min(MAXL, r.lines.length)), placeholder: 'One line of text per row', onchange: function () { r.lines = this.value.split(/\r?\n/).slice(0, MAXL); redo(); } });
      ta.value = r.lines.join('\n');
      f.appendChild(h('label', { class: 'npb-txt' }, ['Text (one line per row)', ta]));
      var st = h('div', { class: 'npb-st' });
      if (res.ok) {
        var v = res.variant, each = tierPrice(v, r.qty);
        st.appendChild(h('span', { class: 'ok', text: '✓ ' + res.plate + ' · letters ' + res.lines.map(function (x) { return x.label; }).join(' / ') }));
        st.appendChild(h('span', { class: 'pr', text: r.qty + ' × ' + money(each) + ' = ' + money(each * r.qty) }));
      } else res.errors.forEach(function (e) { st.appendChild(h('span', { class: 'bad', text: '✕ ' + e })); });
      st.appendChild(h('button', { type: 'button', class: 'npb-del', onclick: function () { rows.splice(rows.indexOf(r), 1); draw(); }, text: 'Remove' }));
      f.appendChild(st);
      el.appendChild(f);
      return el;
    }
    function totals() {
      var n = 0, pcs = 0, sum = 0, bad = 0;
      rows.forEach(function (r) { var c = check(r); if (!c.ok) { bad++; return; } n++; pcs += r.qty; sum += tierPrice(c.variant, r.qty) * r.qty; });
      tot.innerHTML = rows.length ? '<b>' + money(sum) + '</b> for ' + n + ' ' + (window.NP_NOUN || 'nameplate') + ' design' + (n === 1 ? '' : 's') + ' · ' + pcs + ' pcs' + (bad ? '<small style="color:#c62828">' + bad + (bad === 1 ? ' row still needs' : ' rows still need') + ' fixing</small>' : '<small>Estimate at quantity pricing — final price shows in the cart</small>') : '<small>No rows yet — upload a spreadsheet or add a row.</small>';
      addBtn.disabled = !rows.length || bad > 0 || busy;
      addBtn.textContent = rows.length && !bad ? 'Add all ' + n + ' to cart' : 'Add all to cart';
    }
    function draw() {
      list.innerHTML = '';
      rows.forEach(function (r, i) { list.appendChild(rowEl(r, i)); });
      totals();
    }

    var busy = false;
    function addAll() {
      if (busy) return;
      var checked = rows.map(function (r) { return { r: r, c: check(r) }; });
      if (!checked.length || checked.some(function (x) { return !x.c.ok; })) { setMsg('Fix the rows marked in red first.', true); return; }
      busy = true; addBtn.disabled = true;
      var done = 0, items = new Array(checked.length);
      setMsg('Saving a picture of each design (0 of ' + checked.length + ')…');
      var queue = checked.map(function (x, i) { return i; });
      function work() {
        if (!queue.length) return Promise.resolve();
        var i = queue.shift(), x = checked[i];
        return A.snapshot(apiRow(x.r)).then(function (blob) { return A.upload(blob, 'nameplate-' + (i + 1) + '.png'); }).catch(function () { return null; }).then(function (url) {
          var props = {}; x.c.props.forEach(function (kv) { props[kv[0]] = kv[1]; });
          if (url) props['Design Preview'] = url;
          items[i] = { id: x.c.variant.id, quantity: x.r.qty, properties: props };
          done++; setMsg('Saving a picture of each design (' + done + ' of ' + checked.length + ')…');
          return work();
        });
      }
      Promise.all([work(), work(), work()]).then(function () {
        setMsg('Adding ' + items.length + ' nameplates to your cart…');
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j && (j.description || j.message) || 'Could not add to cart'); return j; }); });
      }).then(function () {
        setMsg('Added! Taking you to your cart…');
        window.location.href = '/cart';
      }).catch(function (e) {
        busy = false; totals();
        setMsg('Something went wrong adding to the cart: ' + (e && e.message ? e.message : e) + '. Please try again or call 1-800-627-5255.', true);
      });
    }

    // place the panel full-width under the product area
    var anchor = document.querySelector('.product_main_data_wrapper');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    else { var b = document.getElementById('np-builder'); if (b) b.parentNode.appendChild(wrap); }
    draw();
    if (/[?&]list=1/.test(location.search) || location.hash === '#npb') toggle(true);
  }
  if (window.NPBulk) boot(); else document.addEventListener('npbulk:ready', boot);
})();
